module.exports = __webpack_public_path__ + "img/day_in_the_life.4725cc65.jpg";